import {
  ListItemButton,
  ListItem,
  ListItemText,
  Typography,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getTipoMarcatura, TypeMarcatura } from "../../service/marcature";

const ItemMarcatura = ({ marcatura }: { marcatura: TypeMarcatura }) => {

  const navigate = useNavigate();

  function stringAvatar(nomecognome: string) {
    return {
      children: nomecognome,
    };
  }

  let dataOraMarcatura = "Formato dataora non valido: " + marcatura.dataora; 

  marcatura.dataora = marcatura.dataora.replaceAll("-", "/"); 

  if(marcatura.dataora.match(/^(\d{1,4})[\/|-|.\S](\d{1,2})[\/|-|.|\S](\d{1,4})[\T|\s](\d{1,2})[\:](\d{1,2})[\S|:](\d{2})?[\:|\s|.|Z]?(\d{7})?(?:AM)?(?:PM)?$/)) {

    dataOraMarcatura = format(new Date(marcatura.dataora), "yyyy-MM-dd hh:mm:ss"); 

  }

  return (
    <ListItemButton>
      <ListItem
        onClick={() => navigate("/operatore/" + marcatura.idoperatorecantiere)}
        alignItems="flex-start"
        style={{ cursor: "pointer" }}
      >
        <ListItemText
          primary={marcatura.nomecognome}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                  {dataOraMarcatura} - {marcatura.nomecantiere}
              </Typography>
            </React.Fragment>
          }
        />
        <ListItemAvatar>
          <Avatar {...stringAvatar(getTipoMarcatura(marcatura.tipo))} />
        </ListItemAvatar>
      </ListItem>
    </ListItemButton>
  );
};

export default ItemMarcatura;
